import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

// Hook to get subject configuration settings
export const useSubjectSettings = () => {
  const [settings, setSettings] = useState({
    subject_enabled: 'true',
    subject_name_singular: 'Pet',
    subject_name_plural: 'Pets',
    subject_required_for_booking: 'true',
    subject_icon: '🐾'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const response = await axios.get(`${API_URL}/subject-fields/settings/config`);
        setSettings(prev => ({ ...prev, ...response.data }));
      } catch (error) {
        console.error('Failed to load subject settings:', error);
        // Keep defaults if fetch fails
      } finally {
        setLoading(false);
      }
    };

    loadSettings();
  }, []);

  return {
    settings,
    loading,
    isEnabled: settings.subject_enabled === 'true',
    isRequired: settings.subject_required_for_booking === 'true',
    singularName: settings.subject_name_singular || 'Pet',
    pluralName: settings.subject_name_plural || 'Pets',
    icon: settings.subject_icon || '🐾'
  };
};

export default useSubjectSettings;
